// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__Qz7DP","sm-spinner":"Spinner_sm-spinner__dT6t8"};